import { WebComponent } from '@cian/mf-registry/browser';
import { createRoot, hydrateRoot } from 'react-dom/client';

import { RootApplicationContainer } from '../../shared/common/containers/RootApplicationContainer/RootApplicationContainer';
import { IAppContext } from '../../shared/common/types/applicationContext';
import { TGenericStore } from '../../shared/common/redux';

export function createCustomElementConstructor(context: IAppContext, store: TGenericStore): CustomElementConstructor {
  class OfferCalculator extends WebComponent {
    private applicationContext: IAppContext;

    protected microfrontendName = context.config.getStrict<string>('projectName');
    protected imageVersion = context.config.getStrict<string>('version.commit');
    protected runtimeName = '/v1/get-offer-calculator-by-post/';

    public async connectedCallback(): Promise<void> {
      const s = super.connectedCallback();
      this.applicationContext = { ...context, config: context.config.attach({ instanceId: this.instance.id }) };

      return s;
    }

    public async render() {
      const reactElement = <RootApplicationContainer context={this.applicationContext} reduxStore={store} />;

      if (this.shouldHydrate) {
        hydrateRoot(this, reactElement);
      } else {
        createRoot(this).render(reactElement);
      }
    }
  }

  return OfferCalculator;
}
